import React, { FC, useCallback, useEffect, useState } from "react";
import { Input } from "../input";
import { Select } from "./Select2";
import { Button } from "../button";
import '../../styles/components/customWindow.scss';
import { AdminSettingsService, TimeOptions, TimeOptionsEnum, setClass, useViewModel } from "../../utils";

interface CustomWindowProps {
  onSave: (value: number) => void;
  onCancel: () => void;
  timeOptions?: string[];
}

export const CustomPopup: FC<CustomWindowProps> = ({ onSave: save, onCancel, timeOptions = TimeOptions }) => {
  const adminSettings = useViewModel(AdminSettingsService);
  const [value, setValue] = useState(15);
  const [timeOption, setTimeOption] = useState(TimeOptionsEnum.minute);
  const [max, setMax] = useState(90);
  const isNotification = timeOptions.length <= 2;
  const onChangeTimeOption = (value: string) => value && setTimeOption(value)
  const onChangeValue = (value: number) => value && setValue(value);
  
  
  
  const onChange = useCallback((valueString: string) => {
    if (valueString.match(/^\d*$/)) {
      const num = +valueString;
      if (num <= max && num >= 0) setValue(num)
    }
  }, [max]);

  const onSave = useCallback(() => {
    let minutes = +value;

    if(timeOption === TimeOptionsEnum.hour) {
      minutes *= 60; // часы
    }
    if(timeOption === TimeOptionsEnum.day) {
      minutes *= 60 * 24; // дни
    }

    save(minutes);
  }, [value, timeOption]);

  useEffect(() => {
    if(timeOption === TimeOptionsEnum.minute) {
      setMax(90); // Ограничения на минуты
    } 

    if (isNotification && timeOption === TimeOptionsEnum.hour) {
      setMax(+adminSettings.settings.MAX_REMINDER_TIME_MINUTES / 60); // Ограничение на час для уведомлений
    }

    if (!isNotification) { // Для кастомного отключения
      if (timeOption === TimeOptionsEnum.minute) {
        setValue(15); //Установка значения в 15 минут
      } 
      if (timeOption === TimeOptionsEnum.hour) {
        setMax(24); // Ограничения на часы
      } else if (timeOption === TimeOptionsEnum.day) {
        setMax(+adminSettings.settings.MAX_REMINDER_OFF_TIME_MINUTES / 24 / 60); // Ограничение на дни
      }
    }
  }, [timeOption]);

  useEffect(() => {
    if (value > max) setValue(max);
  }, [max]);

  return (
    <div className={setClass("custom-window-wrapper", isNotification && 'small')}>
      <div className="custom-window-input-area">
        {isNotification || (timeOption !== TimeOptionsEnum.minute)
          ? (
            <Input 
              variant={"underlined"}
              value={value.toString()} 
              onChange={onChange}
              classes="custom-window-input-text"
              divClasses="custom-window-input-wrapper"
            />
          )
          : (
            <Select 
              value={value} 
              options={[15, 30, 60, 90]} 
              placeholder={"Выберите"} 
              onChange={onChangeValue} 
              commonContent
              renderOption={(option: number) => <div className="select-content">{option}</div>}
              variant="underlined"
              smallArrow 
            />
          )
        }
        
        <div className="custom-window-select-wrapper">
          <Select 
            value={timeOption} 
            options={timeOptions} 
            placeholder={"Выберите"} 
            onChange={onChangeTimeOption} 
            commonContent
            renderOption={(option: string) => <div className="select-content">{option}</div>}
            variant="underlined"
            smallArrow 
          />
        </div>
      </div>
      
      <div className={setClass("custom-window-buttons", isNotification && 'small')}>
        <Button 
          title="Подтвердить"
          className="small-long"
          onClick={onSave} 
        />
        <Button 
          title="Отмена"
          className="outlined small-long"
          onClick={onCancel} 
        />
      </div>
    </div>
  )
}
